<template>
  <b-modal
    id="share-project-modal"
    :title="$translate('Share')"
    centered
    content-class="rounded-8"
    hide-footer
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <div class="line-box" @click="sendEmail">
          <div class="line-icon">
            <div class="email-icon" />
          </div>
          <div class="line-text">
            <span>Email</span>
          </div>
        </div>
        <div @click="copyText">
          <div class="link-text">
            {{ copied ? $translate('Link copied') : $translate('Click to copy link') }}
          </div>
          <div class="link-box">
            <div id="link" class="link">
              {{ link }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  title: 'Share modal',
  data() {
    return {
      copied: false,
    };
  },
  props: {
    project: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    link: function () {
      return window.location.href;
    },
  },
  methods: {
    sendEmail() {
      const emailBody = this.link;
      document.location = 'mailto:body=' + emailBody;
    },
    copyText() {
      const containerid = 'link';
      let range;
      if (document.selection) {
        // IE
        range = document.body.createTextRange();
        range.moveToElementText(document.getElementById(containerid));
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(document.getElementById(containerid));
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
      document.execCommand('copy');
      this.copied = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.link-box {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.link {
  color: rgba(0, 0, 0, 0.87);
  font-size: 16px;
  line-height: 26px;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
}

.link-box {
  cursor: pointer;
}

.email-icon {
  background: url('../../../../../../assets/icons/email.svg') no-repeat !important;
  background-position: center;
  height: 40px;
  width: 40px;
}

.twitter-icon {
  background: url('../../../../../../assets/icons/twitter.svg') no-repeat !important;
  background-position: center;
  height: 40px;
  width: 40px;
}

.facebook-icon {
  background: url('../../../../../../assets/icons/facebook.svg') no-repeat !important;
  background-position: center;
  height: 40px;
  width: 40px;
}

.line-box {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
}

.line-icon {
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.line-text {
  color: rgba(0, 0, 0, 0.87);
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.link-text {
  margin-top: 10px;
  color: rgba(0, 0, 0, 0.54);
  font-size: 13px;
  line-height: 16px;
  padding-top: 8px;
  padding-bottom: 4px;
}

::v-deep .modal-header {
  border: none;
  padding-bottom: 0px!important;
}

::v-deep .rounded-8 {
  border-radius: 8px;
}
</style>
